import React from 'react';
import IconBadge from './IconBadge';

const Badge: React.FC<React.PropsWithChildren<unknown>> = props => (
  <IconBadge url={require('../img/appletv.png')} {...props} />
);

export default Badge;
